export interface ThemeColors {
    background: string;
    text: string;
    hover: string;
    active: string;
    border: string;
    bar: string;
}

export const themeColors: Record<string, ThemeColors> = {
    default: {
        background: 'bg-white',
        text: 'text-neutral-700',
        hover: 'hover:bg-gray-100',
        active: 'bg-cc_bg-active text-cc_brand',
        border: 'border-gray-200',
        bar : 'bg-gray-600'
    },
    Administrator: {
        background: 'bg-purple-100',
        text: 'text-purple-900',
        hover: 'hover:bg-purple-200/70',
        active: 'bg-purple-200 text-purple-900',
        border: 'border-purple-200',
        bar : 'bg-purple-600'
    },
    Manager: {
        background: 'bg-amber-50',
        text: 'text-amber-900',
        hover: 'hover:bg-amber-200/70',
        active: 'bg-amber-200 text-amber-900',
        border: 'border-amber-200',
        bar : 'bg-amber-600'
    },
    Observer: {
        background: 'bg-gray-200',
        text: 'text-gray-700',
        hover: 'hover:bg-gray-100/70',
        active: 'bg-gray-300 text-gray-700',
        border: 'border-gray-200',
        bar : 'bg-gray-400'
    }
};

export const getThemeColors = (role: string): ThemeColors => {
    const theme = themeColors[role] || themeColors.default;
    return theme;
}; 